/**
 * ページに埋め込まれたステージ設定の読み取り。
 *
 * 契約は `05-database-schema.md` §3（`EmbeddedStageConfig`）。型定義は書き手（ビルド時の
 * ページ生成）と共有するため `stage-config-schema.ts` にある。ビルドが各ページへ書き込み、
 * ランタイムはこれを読むだけで、JSON をフェッチすることはない。
 *
 * **値の検証はここで行わない。**分割数の妥当性も `τ` の全単射性もビルド時の検証規則
 * V-1〜V-9 が保証済みで（`04a-puzzle-core.md` §7、TK-016）、ランタイム検証は実装しない方針である
 * （二重に持つと、どちらが正なのかが曖昧になる）。ここが受け持つのは「埋め込みが在るか、
 * JSON として読めるか」までである。
 */

import { type EmbeddedStageConfig, STAGE_CONFIG_ID } from './stage-config-schema';

export type { EmbeddedStageConfig, StageImageSources } from './stage-config-schema';
export { STAGE_CONFIG_ID };

/**
 * 埋め込みステージ設定を読む。無ければ `null`。
 *
 * 埋め込みが無いのは異常ではない。ステージページの生成（TK-017）より前の骨格ページや、
 * 404 ページのように盤面を持たないページがありうる。
 */
export function readStageConfig(doc: Document = document): EmbeddedStageConfig | null {
  const element = doc.getElementById(STAGE_CONFIG_ID);
  if (element === null) return null;
  return JSON.parse(element.textContent ?? '') as EmbeddedStageConfig;
}
